// Б.3: Бишор active — «Нанеси 1 урон себе, дай выбранному юниту +3/0/1 до конца игры».
//
// Цель: любой юнит на поле (свой или вражеский). Героев целью выбрать нельзя.
// Скрытных вражеских юнитов целью выбрать нельзя (стандартное поведение).
// На свои Скрытные юниты — можно (видишь свои).
//
// Эффект:
//   1. Бишор получает 1 ОЗ ПРОБИВАЮЩЕГО урона (игнорирует свою броню). Урон
//      идёт через applyDamage с pierce=true. Это НЕ Мод — счётчик прогрессии
//      Синтетика не тикает, триггер Бишора не срабатывает.
//   2. Если HP Бишора падает до 0 — Бишор умирает (флаг alive=false). Победа
//      проверится стандартным checkMatchOver (вызовет вызывающий код).
//   3. Цель получает перманентный бафф +3/0/1 до конца матча:
//      • current.atk += 3
//      • base.hp += 1, current.hp += 1 (max растёт, current тоже)
//      • броня +0 (без изменений)
//   4. Бафф НЕ Мод: не входит в modifications массив, Бишор-trigger не
//      срабатывает, прогрессия не тикает.
//   5. Бафф НЕ снимается смертью Бишора (это «до конца игры», а не «до
//      смерти источника»).

import { applyDamage } from '../../combat.js';
import { hasKeyword, KW } from '../../keywords.js';

export const HERO_ID = 'syn_bishor';

// Цели: любой юнит на поле (свой или вражеский), кроме Героев и Скрытных
// вражеских юнитов. Pure-функция для UI/picker.
export function getBishorActiveTargets(state, playerIdx) {
  const me    = state.players[playerIdx];
  const enemy = state.players[1 - playerIdx];
  const out = [];
  for (const u of me.unitsOnField()) out.push(u);            // свои — все
  for (const u of enemy.unitsOnField()) {
    if (hasKeyword(u, KW.STEALTH)) continue;
    out.push(u);
  }
  return out;
}

export function bishorActiveAvailable(state, playerIdx) {
  const p = state.players[playerIdx];
  if (!p || p.hero.id !== HERO_ID) return false;
  if (p.heroActiveUsed) return false;
  if (p.hero.hp <= 0) return false;
  // Активка тратит 1 ОЗ — должна быть валидная цель в виде юнита на поле,
  // иначе использование = только урон себе без эффекта (бессмысленно).
  if (getBishorActiveTargets(state, playerIdx).length === 0) return false;
  return true;
}

// Возвращает {ok} либо {ok:false, reason}.
export function bishorActive(state, playerIdx, targetCard) {
  if (!bishorActiveAvailable(state, playerIdx)) {
    return { ok: false, reason: 'unavailable' };
  }
  if (!targetCard || targetCard.type !== 'unit' || !targetCard.isAlive()) {
    return { ok: false, reason: 'invalid_target' };
  }
  const validTargets = getBishorActiveTargets(state, playerIdx);
  if (!validTargets.includes(targetCard)) {
    return { ok: false, reason: 'invalid_target' };
  }
  const p = state.players[playerIdx];
  // 1) Урон 1 себе — пробивающий, в обход системы Модов и триггеров.
  const beforeHero = { hp: p.hero.current.hp, armor: p.hero.current.armor };
  applyDamage(p.hero, 1, { pierce: true });
  state.log.add(
    `✨ Бишор [${p.name}] [active]: -1 HP себе ` +
    `(HP ${beforeHero.hp}→${p.hero.current.hp}, броня ${beforeHero.armor}→${p.hero.current.armor})`
  );
  if (p.hero.current.hp <= 0) {
    state.log.add(`💀 ${p.hero.name_ru} [${p.name}] пал от своей активки`);
  }
  // 2) Бафф +3/0/1 цели. Применяем как «императивную дельту» — без Мода.
  const beforeTarget = {
    atk: targetCard.current.atk,
    hp: targetCard.current.hp,
    maxHp: targetCard.base.hp
  };
  targetCard.current.atk += 3;
  // +1 max и +1 current (с cap'ом на новый max — но т.к. оба +1, после операции
  // current может стать ровно maxHp, не превысит).
  targetCard.base.hp    += 1;
  targetCard.current.hp = Math.min(targetCard.current.hp + 1, targetCard.base.hp);
  const ownerName = state.players[targetCard.ownerId]?.name || '?';
  state.log.add(
    `✨ Бишор [active] → ${targetCard.name_ru} [${ownerName}]: +3/0/1 ` +
    `(atk ${beforeTarget.atk}→${targetCard.current.atk}, ` +
    `HP ${beforeTarget.hp}→${targetCard.current.hp}, ` +
    `maxHP ${beforeTarget.maxHp}→${targetCard.base.hp})`
  );
  p.heroActiveUsed = true;
  return { ok: true };
}
